import { COLOR } from '@/utils/enum'
import ArrayDecorator from '@/utils/ArrayDecorator'
import DataChunk from '@/vue-prop-types/Statistics/DataChunk'

export default class StatisticDataSet extends ArrayDecorator {
  get dataPoints() {
    return this.data.map((chunk) => chunk.value)
  }

  constructor({ legend = null, color = null, dataPoints = [], id = 0 } = {}) {
    super(dataPoints.map((chunk) => new DataChunk(chunk)))
    this.legend = legend
    this.color = color || StatisticDataSet.getDefaultColorFromId(id)
  }

  convertToFormat(format) {
    this.data.forEach((chunk) => chunk.convertToFormat(format))
  }

  /**
   * Note: since we are not actually returning colors from the statistics gql api, then it always triggers here
   * and basically uses the first x colors in the COLOR enum
   * Gets the default color to use from the given id
   * @param {int} id
   * @return {string}
   */
  static getDefaultColorFromId(id) {
    const options = Object.keys(COLOR)
    // We remove any excess ie we have an id higher that the number of color options
    const index = id % options.length
    return COLOR[options[index]]
  }
}
